import React from 'react';
import PropTypes from 'prop-types';

function VeriffThankYouPage({ translate }) {
  return (
    <React.Fragment>
      <div className='text-logo' />
      <h1 className='veriff-thank-you-text'>{translate('Heading.ThankYou')}</h1>
      <p className='veriff-info-text'>{translate('Description.VerificationFinished')}</p>
    </React.Fragment>
  );
}

VeriffThankYouPage.propTypes = {
  translate: PropTypes.func.isRequired
};

export default VeriffThankYouPage;
